import { ActionType } from "../types/store-types";

export interface IUserOptionsData {
  isOpen: boolean;
}

export interface IColorData {
  isStyleVisible: boolean;
  solid: string | null;
  gradient: string | null;
  imageUrl: string | null;
}

/* - State - */

export interface IUIState {
  userOptions: IUserOptionsData;
}

/* - Action Types - */

export enum UIActionTypes {
  CHANGE_CURRENT_LOGIN_POPUP_STATE = "UI.CHANGE_CURRENT_LOGIN_POPUP_STATE",
  CHANGE_USER_OPTIONS = "UI.CHANGE_USER_OPTIONS",
  CHANGE_CURRENT_POPUP = "UI.CHANGE_CURRENT_POPUP",
}

/* - Action Interfaces  - */

export type ChangeUserOptionsActionType = ActionType<
  UIActionTypes.CHANGE_USER_OPTIONS,
  IUserOptionsData
>;
